class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupAccordions();
  }

  setupAccordions() {
    const accordions = this.querySelectorAll('details');
    
    accordions.forEach((accordion) => {
      const summary = accordion.querySelector('summary');
      const content = accordion.querySelector('.accordion__content');
      
      if (!summary || !content) return;

      // Prevent default toggle behavior to control animation
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(accordion, content);
      });

      // Set initial state
      if (!accordion.hasAttribute('open')) {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';
      }
    });
  }

  toggleAccordion(accordion, content) {
    const isOpen = accordion.hasAttribute('open');
    
    if (isOpen) {
      // Closing
      content.style.maxHeight = content.scrollHeight + 'px';
      
      // Force reflow
      void content.offsetHeight;
      
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
      
      setTimeout(() => {
        accordion.removeAttribute('open');
      }, 300);
    } else {
      // Opening
      accordion.setAttribute('open', '');
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
      
      // Force reflow
      void content.offsetHeight;
      
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
      
      // Reset max-height after animation
      setTimeout(() => {
        content.style.maxHeight = 'none';
      }, 300);
    }
  }
}

customElements.define('collapsible-content', CollapsibleContent);
